module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/4-77a9bdc84ced0221452ae853cddbe14f.webp";